import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Observable} from "rxjs";

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate (
        route : ActivatedRouteSnapshot,
        state : RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {

      if (!localStorage.getItem('currentUser')) {
          this.router.navigate(['/login'],{ queryParams: { returnUrl: state.url }});
          return false;
      }
      var user = localStorage.getItem('currentUser');
      const token = JSON.parse(user).token;
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace('-', '+').replace('_', '/');
      const decoded = JSON.parse(window.atob(base64));

      let valid = Math.round(new Date().getTime() / 1000) <= decoded.exp;
      if (!valid)
        this.router.navigate(['/login'],{ queryParams: { returnUrl: state.url }});
          //this.router.navigate(['/login']);

      return valid;

    }

}



// WEBPACK FOOTER //
// /Users/alexandre/Documents/web/riberfuso/resources/ng/src/app/guards/auth.guard.ts